import { memo } from 'react';

import cn from 'classnames';

import { OPopper } from '@src/shared';

import { BiDotsHorizontalRounded } from 'react-icons/bi';

import { IActionMenuProps } from '../videoBox.types';

import styles from '../videoBox.module.scss';

const ActionMenu: React.FC<IActionMenuProps> = ({
  isMobile,
  isDrawerOpen,
  isMenuPopperOpened,
  setIsMenuPopperOpened,
  hoveredVideoBox,
  whiteboardSettings,
  handleDrawerToggle,
  videoActions,
}) => {
  if (isMobile) {
    if (!isDrawerOpen) {
      return (
        <button
          className={cn(styles.iconContainer, { active: isMenuPopperOpened, mobile: isMobile })}
          onClick={handleDrawerToggle}
        >
          <BiDotsHorizontalRounded size={24} />
        </button>
      );
    }
    return null;
  }
  if (hoveredVideoBox && !whiteboardSettings.isActive) {
    return (
      <OPopper
        icon={
          <div
            className={cn(styles.iconContainer, { active: isMenuPopperOpened })}
            style={{ backgroundColor: 'transparent' }}
          >
            <BiDotsHorizontalRounded size={24} />
          </div>
        }
        customStyles={{
          root: {
            backgroundColor: 'var(--public-chat-bg)',
          },
        }}
        onClose={() => setIsMenuPopperOpened(false)}
        onOpen={() => setIsMenuPopperOpened(true)}
        isActive={isMenuPopperOpened}
        offset={[0, 8]}
      >
        <div className={styles.actionBoxMenu}>
          {videoActions.map((action) => (
            <button className={styles.menuItem} onClick={action.action} key={action.label}>
              {action.label}
            </button>
          ))}
        </div>
      </OPopper>
    );
  }
  return null;
};

export default memo(ActionMenu);
